
import * as Vue from 'vue';
import Icon from './components/abstracts/Icon';
import Loader from './components/abstracts/Loader.vue';
import { formatPrettyNoSymbol, formatPretty } from './money';
import { formatISO } from './dates';


const mixins: Vue.ComponentOptions = {
    components: {
        Icon,
        Loader,
    },
    methods: {
        /**
         * Format some moneys.
         *
         * Beware, this only accepts integer money.
         */
        money(value: any, currency = 'aud'): string {
            if (value === null || value === undefined) {
                return '...';
            }

            return formatPretty(value, 'en-AU', currency);
        },

        /**
         * Format money without a currency symbol.
         *
         * This only accepts integer.
         */
        moneyValue(value: any, currency = 'aud'): string {
            if (value === null || value === undefined) {
                return '...';
            }

            return formatPrettyNoSymbol(value, 'en-AU', currency);
        },

        /**
         * Format a date.
         *
         * This is just the date component, formatted nicely in however style
         * the browser wants.
         *
         * This may be locale dependent. Honestly I don't know.
         *
         * Like: 'Thu Mar 10 2022' or something.
         */
        formatDate(date: Date) {
            if (!date) return '';
            return date.toDateString();
        },

        /**
         * Format a date in ISO.
         *
         * This returns only the date component.
         *
         * Like: '2022-12-31'.
         */
        formatDateISO(date: Date) {
            if (!date) return '';
            return formatISO(date);
        },

        /**
         * Format a date in the current locale.
         *
         * Like: '31/12/2022'.
         */
        formatDateLocal(date: Date) {
            return date && date.toLocaleDateString('en-au');
        },
    }
}

export default mixins;
